import jwt from 'jwt-decode';

export const getTokenData = (token: string) => {
  const decodedToken: any = jwt(token);
  const username: string = decodedToken.sub;
  const exp: number = decodedToken.exp;

  return { username, exp };
};
